






import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';

@Component({
  components: {
  }
})
export default class BoxTextComponent extends Vue {
  @Prop({default: () => '' as string})
  public title!: '';

  @Prop({default: () => '' as string})
  public data!: '';



}
